import React from 'react'
import ReviewItem from './reviewItem.jsx'
import { string, object } from 'prop-types'

class ReviewItems extends React.Component {
  render () {
    const { reviews, search } = this.props
    const reviewItems = [ ]
    for (let i in reviews) {
      reviewItems.push(<ReviewItem key={i} search={search} item={reviews[i]} />)
    }

    return (
      <div>
        { reviewItems }
      </div>
    )
  }
}

ReviewItems.propTypes = {
  reviews: object.isRequired,
  search: string
}

export default ReviewItems



// WEBPACK FOOTER //
// ./shared/_layouts/_templates/_includes/reviews/reviewItems.jsx